function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.31 15L12.643 3.333 15 .976 29.024 15 15 29.024l-2.357-2.357z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.66 13.333v3.334H0v-3.334z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 30 30"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzAgMzAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTI0LjMwOTY0NDEgMTUtMTEuNjY2NjY2Ny0xMS42NjY2NjY2NyAyLjM1NzAyMjYtMi4zNTcwMjI2IDE0LjAyMzY4OTMgMTQuMDIzNjg5MjctMTQuMDIzNjg5MyAxNC4wMjM2ODkzLTIuMzU3MDIyNi0yLjM1NzAyMjZ6Ii8+PHBhdGggZD0ibTI2LjY1OTIwODkgMTMuMzMzMzMzM3YzLjMzMzMzMzRoLTI2LjY1OTIwODl2LTMuMzMzMzMzNHoiLz48L3N2Zz4=";
export { SvgComponent as ReactComponent };


// WEBPACK FOOTER //
// ./src/assets/svg/icon-arrow-right.svg